<nz-input-group [nzSuffix]="copyBtnTpl" class="suffix-margin-right-1">
    <nz-select 
        [formControl]="itemsFormControl"
        [nzTokenSeparators]="itemsTokenSeparators"
        class="top-control-no-border multi-text-select full-width"
        [id]="selectElementId"
        [attr.data-testid]="selectElementId"
        [nzPlaceHolder]="placeHolder"
        nzMode="tags"
        nzShowArrow="false"
        nzAllowClear
        nzShowSearch
        [nzDropdownRender]="enableCsvUpload ? uploadDropdownTpl : null"
        [nzMaxTagCount]="maxTagCount"
        [nzMaxTagPlaceholder]="maxTagPlaceholder">
    </nz-select>
  </nz-input-group>
  
  <ng-template #copyBtnTpl>
    <div class="display-flex align-items-center">
        <span class="smaller-font bold-font font-icon-color-darker margin-right-small background-white"
              *ngIf="isCopiedItems" @fadeOut>Copied to clipboard</span>
      <fa-icon icon="copy"
            *ngIf="itemsFormControl.value && itemsFormControl.value.length"
            (click)="clipboardCopy(itemsFormControl.value, true)"
            class="font-icon-color-darker cursor-pointer background-white margin-right-small"
            id="copyToClipboardBtn-apReviewAppSites" data-testid="copyToClipboardBtn-apReviewAppSites"></fa-icon>
    </div>
  </ng-template>

  <ng-template #maxTagPlaceholder let-omittedValues>
    <span>+{{ omittedValues.length }} ...</span>
  </ng-template>

  <!-- Custom dropdown template with CSV upload option -->
  <ng-template #uploadDropdownTpl let-origin>
    <div class="csv-upload-trigger" *ngIf="enableCsvUpload">
      <span>Add manually above and/or</span>
      <app-upload-file
        [type]="'text'"
        [multipleFiles]="false"
        [showUploadList]="false"
        [permittedFileTypes]="fileTypes"
        [(fileList)]="uploadedFile"
        [validationFuncs]="[csvParsingValidation]"
        (fileChange)="onFileUploadFinished($event)"
        (fileRemove)="onFileRemoved($event)">
        <span class="upload-link">Upload CSV</span>
      </app-upload-file>
    </div>
    
    <ng-container *ngTemplateOutlet="origin"></ng-container>
  </ng-template>